module.exports = __webpack_public_path__ + "img/logo-dcc.119b091b.png";